import React from "react";
import clsx from "clsx";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import { Dialog, DialogActions, DialogContent } from "@mui/material";
import { Button, Typography, Box } from "@curves/ui-base";

/** ================================
 * 📌 量身使用
 * 阻抗視窗
 * onRedoMeasurement 重新量身
 *  ================================
 */
const InBodyImpedanceWarningDialog = React.forwardRef((props, ref) => {
	const { open, onClose: onCloseProps, sourceData: sourceDataProps } = props;
	if (!open) return null;
	const { onRedoMeasurement } = sourceDataProps;

	if (!open) return null;
	return (
		<Dialog className={clsx("simple-content", "dialog")} PaperProps={{ className: "wx-65rem" }} open={open} fullWidth>
			<GradientColorHeader onClose={onCloseProps}>量身阻抗異常</GradientColorHeader>
			<DialogContent>
				<Typography paragraph>將造成量身數據不準確，需請會員再次量身，並請注意下述情況</Typography>
				<Box component="ul" className="list list-num-sub">
					<Box component="li">測量電極與皮膚的接觸不良，請擦拭InBody電極或使用濕紙巾或乾淨的布擦拭測量部位的皮膚。</Box>
					<Box component="li">避免附近有強電磁干擾源（如手機、無線設備等）。</Box>
					<Box component="li">檢查設備的狀態，若持續異常請換人量身或重新開啟InBody</Box>
				</Box>
			</DialogContent>
			<DialogActions>
				<Button color="error" variant="contained" onClick={onCloseProps}>
					否
				</Button>
				<Button color="success" variant="contained" onClick={onRedoMeasurement}>
					是，再次量身
				</Button>
			</DialogActions>
		</Dialog>
	);
});

export default InBodyImpedanceWarningDialog;
